import { useEffect, useState } from "react";

import ReturnButton from "../../components/Buttons/ReturnButton";
import PageTitle from "../../components/PageTitle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";
import Style from "./UserJournalSessionStyle";
import { customDateTimeFormat, Sort } from "../../utils";

export interface JournalSessionContent {
  id: number;
  description: string;
  content: string;
  createdAt: number;
}

export function UserJournalSession(props) {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [journalSessions, setJournalSessions] = useState<JournalSessionContent[]>([]);

  const sessionId = parseInt(props.match?.params?.sessionId) || 0;

  useEffect(() => {
    getUserJournalSessionRequest();
  }, []);

  async function getUserJournalSessionRequest() {
    try {
      setLoading(true);
      const result = await api.get(`journal/sessions/${sessionId}`);
      console.log(result);
      if (result.data.success) {
        setJournalSessions(Sort(result.data.sessions, s => s.createdAt, true));
      } else {
        setErrorMessage(
          result.data?.message || "Não foi possível buscar dados de sessão"
        );
        console.error("Não pode pegar os dados de sessão: ", result.data);
      }
    } catch (error: any) {
      console.error("Erro pegando os dados de sessão: ", error);
      setErrorMessage(
        error.response?.data?.message ||
        "Não foi possível buscar os dados de sessão"
      );
    } finally {
      setLoading(false);
    }
  }


  return (<Style className="default-page">
    <PageTitle title="Detalhes do Usuário" />
    <Spinner spinning={loading} />
    {errorMessage !== "" && <h1 className="alert"> {errorMessage}</h1>}
    <ReturnButton history={props.history} />
    <main className="default-main">
      <div className="panel">
        {journalSessions.map(session => <button className="section-button">
          <div className="section">
            <div>Id: {session.id}</div>
            <div>{customDateTimeFormat(session.createdAt)}</div>
          </div>
          <div className="description">{session.description}</div>
          <div className="content">{session.content}</div>
        </button>)
        }
      </div>
    </main>
  </Style>
  );
}
